import React from 'react';
import { motion } from 'framer-motion';
interface BannerCardProps {
  title: string;
  subtitle: string;
  imageUrl: string;
  imageAlt: string;
  delay?: number;
}
export const BannerCard = ({
  title,
  subtitle,
  imageUrl,
  imageAlt,
  delay = 0
}: BannerCardProps) => {
  return <motion.article initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className="group w-full rounded-xl overflow-hidden border border-we-gold/30 z-10 relative shadow-2xl aspect-[16/10] md:aspect-[16/9]" data-id="element-1">
      {/* Background image */}
      <img src={imageUrl} alt={imageAlt} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-2" />

      {/* Readability gradient — darkens the bottom where text sits */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" aria-hidden="true" data-id="element-3" />

      {/* Content overlay */}
      <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 flex flex-col items-center text-center" data-id="element-4">
        <h2 className="font-serif text-2xl md:text-3xl text-we-gold mb-1.5 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]" data-id="element-5">
          {title}
        </h2>
        <p className="text-white font-light text-xs md:text-sm mb-4 max-w-sm leading-relaxed drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)]" data-id="element-6">
          {subtitle}
        </p>
        <a href="#" className="inline-block px-6 py-2 rounded-md border border-we-gold text-we-gold bg-black/40 backdrop-blur-sm hover:bg-we-gold hover:text-black transition-all duration-300 text-sm font-medium tracking-wide" data-id="element-7">
          Ver Oferta
        </a>
      </div>
    </motion.article>;
};